export enum CoPaymentEnum {
  CHARGED,
  NOT_CHARGED,
}

export const translateKey = (value: string): string => {
  return "coPayment." + value.toLowerCase();
};

export const allCoPayments = () => {
  return [CoPaymentEnum.CHARGED, CoPaymentEnum.NOT_CHARGED];
};
